import clsx from 'clsx'
import { ISelectProps } from './types'
import sharedStyles from '@muiscss/sharedStyles.module.scss'
import styles from './styles.module.scss'
import { forwardRef } from 'react'

/**
 * @deprecated use `SelectMultiple` or `SelectSingle` instead
 */
const Select = forwardRef<HTMLSelectElement, ISelectProps>(
  (
    {
      error,
      hasError,
      label,
      options,
      size = 'md',
      slots,
      transparent = false,
      value,
      className,
      isTiny = false,
      ...props
    },
    ref,
  ) => {
    // remove after deprecated hasError is replaced with error
    const tempoVarError = error || hasError

    const getValueProps = () => {
      if (value !== undefined && value !== null) return { value }
      if (props.defaultValue !== undefined && props.defaultValue !== null)
        return { defaultValue: props.defaultValue }
      /**
       * if placeholder is set we set the `defaultValue` to an empty string as the placeholder's value is ''
       * we return `defaultValue` as the select component is an uncontrolled component by default
       */
      if (props.placeholder) return { defaultValue: '' }
    }

    return (
      <div className={clsx(styles.wrapper, { [styles.tiny]: isTiny })} style={props.style}>
        {label && (
          <label
            className={clsx('mui-select-label', sharedStyles.label, sharedStyles[size], {
              [sharedStyles.disabled]: props.disabled,
            })}
            data-testid="mui-label"
            htmlFor={props.id}
          >
            <span className="mui-select-label-text">{label}</span>
          </label>
        )}
        <div className={styles.innerHolder}>
          <select
            className={clsx(
              'mui-select',
              styles.select,
              styles[size],
              {
                [styles.withSlotsBefore]: Boolean(slots?.before),
                [sharedStyles.disabled]: props.disabled,
                [styles.error]: Boolean(tempoVarError),
                [styles.transparent]: transparent,
                [styles.tiny]: isTiny,
              },
              className,
            )}
            data-testid="mui-select"
            ref={ref}
            {...getValueProps()}
            {...props}
          >
            {props.placeholder && (
              <option value="" disabled>
                {props.placeholder}
              </option>
            )}
            {options?.map((option) => {
              return (
                <option
                  disabled={option.disabled}
                  id={option.id}
                  key={option.id}
                  selected={option.selected}
                  value={option.id}
                >
                  {option.label}
                </option>
              )
            })}
          </select>
          {slots?.before && (
            <span
              className={clsx(styles.slotsBefore, styles[size], {
                [styles.transparent]: transparent,
                [styles.disabled]: props.disabled,
              })}
            >
              {slots.before}
            </span>
          )}
        </div>
        {typeof error === 'string' && <span className={styles.errorMessage}>{error}</span>}
      </div>
    )
  },
)

Select.displayName = 'Select'

export default Select
